var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12,
    fill: "url(#cancel_svg__80vwtmw14a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.925 15.001l4.125-4.124a.655.655 0 10-.927-.927l-4.125 4.125-4.124-4.125a.656.656 0 00-.927.927L14.072 15l-4.125 4.125a.655.655 0 10.927.927l4.124-4.125 4.125 4.125a.653.653 0 001.119-.464.655.655 0 00-.192-.463L15.925 15z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cancel_svg__80vwtmw14a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(8.40284 18.66353 -19.41215 8.73989 6.597 8.336)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgCancel;